// FILECONTENT_START src/common/components/Calendar/CalendarHeaderCell.tsx
import { Box, BoxProps, styled, Typography } from "@mui/material";

import { CalendarHeaderItem, VIEWS } from "./calendarApi";
import { CALENDAR_MONTH_CELL_WIDTH } from "./CalendarCell";

interface ContainerProps extends BoxProps {
  view?: VIEWS;
}
const Container = styled(Box, {
  shouldForwardProp: prop => prop !== "view",
})<ContainerProps>`
  min-width: ${CALENDAR_MONTH_CELL_WIDTH};
  max-width: ${CALENDAR_MONTH_CELL_WIDTH};
  flex: 1;
  //max-width: ${props => (props.view === VIEWS.WEEK ? "160px" : "")};
  display: flex;
  //justify-content: center;
  align-items: ${props =>
    props.view === VIEWS.MONTH ? "center" : "flex-start"};
  //padding: ${props => props.theme.spacing(0.5)};
  //background-color: red;
`;

export interface CalendarHeaderCellProps extends BoxProps, CalendarHeaderItem {
  view: VIEWS;
}
export default function CalendarHeaderCell({
  view,
  dayNameShort,
}: CalendarHeaderCellProps) {
  if (view === VIEWS.MONTH) {
    return (
      <Container key={dayNameShort} view={view}>
        <Typography variant="body1" align="center">
          {dayNameShort}
        </Typography>
      </Container>
    );
  }
  return <Container key={dayNameShort} view={view}></Container>;
}

// FILECONTENT_END src/common/components/Calendar/CalendarHeaderCell.tsx